import type { ReactNode } from 'react';
import { Link } from 'react-router';

import styles from './MarketingCta.module.css';

type SecondaryCTAProps =
  | {
      className?: string;
      href: string;
      icon?: ReactNode;
      label: string;
      onClick?: never;
    }
  | {
      className?: string;
      href?: never;
      icon?: ReactNode;
      label: string;
      onClick: () => void;
    };

function classNames(...values: Array<string | false | null | undefined>) {
  return values.filter(Boolean).join(' ');
}

export function SecondaryCTA({
  className,
  href,
  icon,
  label,
  onClick,
}: SecondaryCTAProps) {
  const classes = classNames(styles.cta, styles.secondary, className);

  // An in-page target: a router Link would push history without scrolling, so
  // let the browser follow the fragment itself.
  if (href?.startsWith('#')) {
    return (
      <a className={classes} href={href}>
        <span>{label}</span>
        {icon ? <span className={styles.icon}>{icon}</span> : null}
      </a>
    );
  }

  if (href) {
    return (
      <Link className={classes} to={href}>
        <span>{label}</span>
        {icon ? <span className={styles.icon}>{icon}</span> : null}
      </Link>
    );
  }

  return (
    <button className={classes} onClick={onClick} type="button">
      <span>{label}</span>
      {icon ? <span className={styles.icon}>{icon}</span> : null}
    </button>
  );
}
